module.exports = __webpack_public_path__ + "static/media/KDAA1_2.45e7a5bd.png";